// import { SlesPgtCatalogDefinitionId } from 'utils/catalogDefinitionId';

// Marks each "Additional Application Server Configuration" card as configured when its saved data exists
const getServerConfigStatus = (catalogConfig, vmNetworkConfig) => ({
    coreComponents: !!catalogConfig?.coreComponents,
    vmNetworkConfig: !!vmNetworkConfig?.availabilitySet,
    proximityConfig: !!catalogConfig?.proximityConfig,
    anfConfig: !!catalogConfig?.anfConfig,
    sapBinaryConfig: !!catalogConfig?.sapBinaryConfig,
});

// eslint-disable-next-line no-unused-vars
export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const vmNetworkConfig = catalogConfig?.vmNetworkConfig || null;
    const anfConfig = catalogConfig?.anfConfig || null;

    const costCenter = entityDetails?.costCenter || environmentDetails?.costCenter || null;

    return {
        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: costCenter,
            projectName: entityDetails?.project || environmentDetails?.projectName,
        },
        sector: data?.itemDetail?.catalogService?.sector || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        hCode: costCenter,
        ...(costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,

        // Resource Section
        resourceGroup: vmNetworkConfig?.resourceGroup || null,
        resourceGroupDetails: null,
        subscription: vmNetworkConfig?.subscription || null,
        subscriptionDetails: {
            subscriptionId: vmNetworkConfig?.subscriptionId,
            subscriptionName: vmNetworkConfig?.subscription,
        },
        vnetDR: vmNetworkConfig?.virtualNetwork || null,
        vnetDRDetails: environmentDetails?.virtualNetworkId ? { data: { vnetId: environmentDetails?.virtualNetworkId } } : null,
        subnetDR: vmNetworkConfig?.subNetName || null,
        applicationSecurityGroup: vmNetworkConfig?.applicationSecurityGroup || null,
        netAccountName: anfConfig?.accountName || null,
        netResourceGroup: anfConfig?.resourceGroup || null,
        capacityPoolName: anfConfig?.capacityPoolName || null,
        netVnetDR: anfConfig?.virtualNetwork || null,
        netSubnetDR: anfConfig?.subNetName || null,
        sapSid: catalogConfig?.sapUserName?.slice(0, 3),
        sapGid: catalogConfig?.sapGroupName,
        sapFeature: catalogConfig?.sapFeatures?.[0] || null,
        ...(catalogConfig?.sapAccountOwner && {
            sapAccountOwner: null,
            sapAccountOwnerDetails: { name: catalogConfig?.sapAccountOwner?.name, gpid: catalogConfig?.sapAccountOwner?.gpid },
        }),
        catalogOffer: catalogConfig?.os?.offer || null,
        osType: catalogConfig?.os?.osType || null,
        osVersion: catalogConfig?.os?.sku || null,
        ...(catalogConfig?.os?.sku && { osVersionDetail: { sku: catalogConfig?.os?.sku, publisher: catalogConfig?.os?.publisher } }),
        sapSolution: catalogConfig?.sapSolution,
        vmType: vmNetworkConfig?.vmType || null,
        vmTypeDetails: vmNetworkConfig?.vmType
            ? {
                  name: vmNetworkConfig?.vmType,
                  displayName: vmNetworkConfig?.vmType,
                  ...(vmNetworkConfig?.availabilityZones && { availabilityZones: vmNetworkConfig?.availabilityZones }),
              }
            : null,
        serverConfigStatus: getServerConfigStatus(catalogConfig, vmNetworkConfig),
        serverConfigData: {
            coreComponents: catalogConfig?.coreComponents || null,
            proximityConfig: catalogConfig?.proximityConfig || null,
            anfConfig: catalogConfig?.anfConfig || null,
            sapBinaryConfig: catalogConfig?.sapBinaryConfig || null,
            vmNetworkConfig: { availabilitySet: vmNetworkConfig?.availabilitySet || null },
        },
        ...(vmNetworkConfig?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: vmNetworkConfig?.availabilityZones,
            availabilityZoneOptions: vmNetworkConfig?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(vmNetworkConfig?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        quantity: data?.itemDetail?.catalogService?.quantity,
        timeZone: data?.itemDetail?.catalogService?.timeZone,
        estimatedCost: data?.itemDetail?.catalogService?.estimatedCost || null,

        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

// eslint-disable-next-line no-unused-vars
export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const vmNetworkConfig = catalogConfig?.vmNetworkConfig || null;
    const anfConfig = catalogConfig?.anfConfig || null;

    return {
        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: environmentDetails?.costCenter,
            projectName: environmentDetails?.projectName,
            sector: catalog?.sector,
        },
        sector: catalog?.sector || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,

        // Resource Section
        resourceGroup: vmNetworkConfig?.resourceGroup || null,
        resourceGroupDetails: null,
        subscription: vmNetworkConfig?.subscription || null,
        subscriptionDetails: {
            subscriptionId: vmNetworkConfig?.subscriptionId,
            subscriptionName: vmNetworkConfig?.subscription,
        },
        vnetDR: vmNetworkConfig?.virtualNetwork || null,
        vnetDRDetails: environmentDetails?.virtualNetworkId ? { data: { vnetId: environmentDetails?.virtualNetworkId } } : null,
        subnetDR: vmNetworkConfig?.subNetName || null,
        applicationSecurityGroup: vmNetworkConfig?.applicationSecurityGroup || null,
        netAccountName: anfConfig?.accountName || null,
        netResourceGroup: anfConfig?.resourceGroup || null,
        capacityPoolName: anfConfig?.capacityPoolName || null,
        netVnetDR: anfConfig?.virtualNetwork || null,
        netSubnetDR: anfConfig?.subNetName || null,
        sapSid: catalogConfig?.sapUserName?.slice(0, 3),
        sapGid: catalogConfig?.sapGroupName,
        sapFeature: catalogConfig?.sapFeatures?.[0] || null,
        ...(catalogConfig?.sapAccountOwner && {
            sapAccountOwner: null,
            sapAccountOwnerDetails: { name: catalogConfig?.sapAccountOwner?.name, gpid: catalogConfig?.sapAccountOwner?.gpid },
        }),
        catalogOffer: catalogConfig?.os?.offer || null,
        osType: catalogConfig?.os?.osType || null,
        osVersion: catalogConfig?.os?.sku || null,
        ...(catalogConfig?.os?.sku && { osVersionDetail: { sku: catalogConfig?.os?.sku, publisher: catalogConfig?.os?.publisher } }),
        sapSolution: catalogConfig?.sapSolution,
        vmType: vmNetworkConfig?.vmType || null,
        vmTypeDetails: vmNetworkConfig?.vmType
            ? {
                  name: vmNetworkConfig?.vmType,
                  displayName: vmNetworkConfig?.vmType,
                  ...(vmNetworkConfig?.availabilityZones && { availabilityZones: vmNetworkConfig?.availabilityZones }),
              }
            : null,
        serverConfigStatus: getServerConfigStatus(catalogConfig, vmNetworkConfig),
        serverConfigData: {
            coreComponents: catalogConfig?.coreComponents || null,
            proximityConfig: catalogConfig?.proximityConfig || null,
            anfConfig: catalogConfig?.anfConfig || null,
            sapBinaryConfig: catalogConfig?.sapBinaryConfig || null,
            vmNetworkConfig: { availabilitySet: vmNetworkConfig?.availabilitySet || null },
        },
        ...(vmNetworkConfig?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: vmNetworkConfig?.availabilityZones,
            availabilityZoneOptions: vmNetworkConfig?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(vmNetworkConfig?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        quantity: catalog?.quantity,
        timeZone: catalog?.timeZone,
        estimatedCost: catalog?.estimatedCost || null,

        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    appProfile: null,
    appProfileDetails: null,
    entityDetails: null,
    businessCategory: null,
    environment: null,
    appTier: null,
    appTierCode: null,
    region: null,
    vmType: null,
    vmTypeDetails: null,
    quantity: 1,
    timeZone: 'UTC',
    timeZoneDetail: null,
    hCode: null,
    hCodeDetails: null,
    sector: null,
    sectorDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    estimatedCost: resetCostEstimateDetails,
    validationStatus: 'clearValidation',
    isTouched: false,
    haDeployment: null,
    availabilityZone: null,
    availabilityZoneOptions: [],
    isValidAvailabilityZone: true,
    sapGid: null,
    sapSid: null,
    sapSolution: null,
    resourceGroup: null,
    resourceGroupDetails: null,
    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isDiskOpen: false,
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
    isApplicationOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    isPgtDiskOpen: false,
};
